const VK_API_ID = 2862513;
const VK_GROUP_ID = 36804143;

class Vkontakte
{
    constructor() {
        try {
            Vkontakte.initGroups();
            Vkontakte.initComments();
        } catch (e) {
            console.error(e.message);
        }
    }

    static initGroups() {
        let container = $('div[id^="vk_groups"]:visible')[0];

        if (container) {
            VK.init({ apiId: VK_API_ID, onlyWidgets: true });

            VK.Widgets.Group(container.id, {
                width: 'auto',
                color1: '333333',
                color2: 'fff',
                color3: 'f24f1d'
            }, VK_GROUP_ID);
        }
    }

    static initComments() {
        let container = document.getElementById('vk_comments');

        if (container) {
            let url = $(container).data('url');

            VK.Widgets.Comments('vk_comments', {
                pageUrl: url ? url : 'https://' + location.hostname + location.pathname
            });

            VK.Observer.subscribe('widgets.comments.new_comment', (num, comment) => {
                $.post($app.urlPrefix + '/service/soc/newComment', {
                    comment: comment,
                    soc: '���������',
                    url: location.pathname
                }, () => {
                    if (location.pathname.indexOf('/help') >= 0) {
                        $app.runEvent('vk-page-help');
                    }
                });
            });
        }
    }
}

module.exports = Vkontakte;